<template>
    <a class="parametric-card" :href="flat.link">
        <div class="parametric-card__content">
            <div class="parametric-card__params">
                <h2 class="parametric-card__title parametric-results__loader">
                    {{ flat.title }}
                    <span v-if="!isEstateFlat && flat.building && flat.section" class="parametric-results__annotation">
                        Корпус {{ flat.building }}, секция {{ flat.section }}
                    </span>
                </h2>

                <ul :class="['parametric-card__params-list', isEstateFlat ? '' : 'commerce']">
                    <li class="parametric-card__params-list-item parametric-results__loader">
                        <span>{{ flat.area }} м<sup>2</sup></span>
                    </li>

                    <li v-if="isEstateFlat" class="parametric-card__params-list-item parametric-results__loader">
                        {{ flat.floor }}/{{ flat.floorsTotal }} этаж
                    </li>

                    <li class="parametric-card__params-list-item parametric-results__loader">
                        {{ flat.checkinText }}
                    </li>
                </ul>

                <div v-if="flat.isBooked" class="parametric-card__state parametric-results__loader">Забронировано</div>

                <div v-if="!flat.isBooked" class="parametric-card__prices">
                    <div class="parametric-results__loader">
                        {{ Number(flat.price) ? `${convertToDigit(flat.price)} руб` : flat.price }}
                    </div>

                    <div v-if="flat.priceOld" class="parametric-card__price-old parametric-results__loader">
                        {{ Number(flat.priceOld) ? `${convertToDigit(flat.priceOld)} руб` : flat.priceOld }}
                    </div>
                </div>
            </div>

            <div class="parametric-card__plan">
                <div class="parametric-results__loader">
                    <img :src="flat.plan" :alt="flat.title">
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import {convertToDigit} from '../../mixins.js';
import {mapGetters} from 'vuex';

export default {
    props   : ['flat'],
    computed: {
        ...mapGetters({
            estateType: 'GET_ESTATETYPE'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },
    mixins: [convertToDigit]
};
</script>
